const breakpoints = {
    mobile: 600,
    portrait: 900,
    landscape: 1200,
    desktop: 1800
};

const Queries = {
    phone: `screen and (max-width:${breakpoints.mobile}px)`,
    tabletPortrait: `screen and (min-width:${breakpoints.mobile + 1}px) and (max-width:${breakpoints.portrait}px)`,
    tabletLandscape: `screen and (min-width:${breakpoints.portrait + 1}px) and (max-width:${breakpoints.landscape}px)`,
    desktop: `screen and (min-width:${breakpoints.landscape + 1}px) and (max-width:${breakpoints.desktop}px)`,
    fullHD: `screen and (min-width:${breakpoints.desktop + 1}px)`
};

export default Queries;